import React from 'react';
import { Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import IndusBenchMark2 from '../echart2/IndusBenchMark2';
import ObservedInd2 from 'pages/Dashboard/ObservedInd2';
const IndexBenchMarking2 = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <h3>Mens Fashionware</h3>
                    <Row>
                        <Col>
                        <IndustryOverview2/>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="8">
                            <IndusBenchMark2/>
                        </Col>
                        <Col lg="4">
                        <ObservedInd2/>
                        </Col>
                    </Row>

                </div>
            </div>
        </React.Fragment>
    );
};

export default IndexBenchMarking2;
